interface CardProps {
  expanded?: boolean;
}

const Logo: React.FC<CardProps> = ({ expanded = true }) => {
  return (
    <div
      style={{ height: `${expanded ? "36" : "40"}px` }}
      className="text-primary text-lg font-bold text-center"
    >
      <img
        src={
          expanded
            ? "/logo/logo-carwash-pos.png"
            : "/logo/logo-secondary-icon.png"
        }
        alt="Logo"
        className="h-8 mx-auto"
      />
    </div>
  );
};

export default Logo;
